export const formatLastViewed = (dateString: string | null) => {
  if (!dateString) {
    return "recently";
  }

  const date = new Date(dateString);
  const diffSeconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));

  if (Number.isNaN(date.getTime()) || diffSeconds < 60) {
    return "just now";
  }

  const minutes = Math.floor(diffSeconds / 60);
  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  const days = Math.floor(hours / 24);
  if (days < 7) {
    return `${days} day${days === 1 ? "" : "s"} ago`;
  }

  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

/**
 * Treat date-only coupon expiries as valid through the end of that day.
 * Unknown or invalid dates are retained so a malformed API value does not
 * accidentally remove a usable coupon.
 */
export const isCouponExpired = (dateString: unknown, now = Date.now()) => {
  if (typeof dateString !== "string" || !dateString.trim()) {
    return false;
  }

  const value = dateString.trim();
  const expiryTime = /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? Date.parse(`${value}T23:59:59.999Z`)
    : new Date(value).getTime();

  return !Number.isNaN(expiryTime) && expiryTime < now;
};
